export default [{
  path: '/enterSchool',
  component: () => import('@/layouts/Router'),
  children: [
    // 进校业务
    {
      path: '',
      component: () => import('@/views/enterSchool' /* webpackChunkName: "schoolDetail" */),
      name: 'enterSchool',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 学校详情
    {
      path: 'schoolDetail',
      component: () => import('@/views/enterSchool/schoolData/schoolDetail' /* webpackChunkName: "schoolDetail" */),
      name: 'schoolDetail',
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 教师详情
    {
      path: 'teacherDetail',
      component: () => import('@/views/enterSchool/teacherDetail' /* webpackChunkName: "teacherDetail" */),
      name: 'teacherDetail',
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    {
      path: '*',
      redirect: '/enterSchool'
    }
  ]
}]
